"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: offer/offer-redemption-error.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Foffer%2Foffer-redemption-error.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.offerRedemptionErrorToJSON = exports.offerRedemptionErrorFromJSON = exports.OfferRedemptionError = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.offer.proto';
var OfferRedemptionError;
(function (OfferRedemptionError) {
    /**
     * INVALID_OFFER_REDEMPTION_ERROR - No error. Code redeemed successfully.
     */
    OfferRedemptionError["INVALID_OFFER_REDEMPTION_ERROR"] = "INVALID_OFFER_REDEMPTION_ERROR";
    /**
     * ALREADY_REDEEMED - Code was already redeemed.
     */
    OfferRedemptionError["ALREADY_REDEEMED"] = "ALREADY_REDEEMED";
    /**
     * USER_INELIGIBLE - User is not eligible to redeem offers.
     */
    OfferRedemptionError["USER_INELIGIBLE"] = "USER_INELIGIBLE";
    /**
     * CODE_NOT_FOUND - No offer found.
     */
    OfferRedemptionError["CODE_NOT_FOUND"] = "CODE_NOT_FOUND";
    /**
     * TOO_MANY_CODES - Number of codes redeemed is over the limit.
     */
    OfferRedemptionError["TOO_MANY_CODES"] = "TOO_MANY_CODES";
    /**
     * EXPIRED - Offer activity period has ended.
     */
    OfferRedemptionError["EXPIRED"] = "EXPIRED";
    /**
     * NOT_STARTED - Offer activity period has not started.
     */
    OfferRedemptionError["NOT_STARTED"] = "NOT_STARTED";
    /**
     * OFFER_GROUP_LIMIT_EXHAUSTED - Offer group max enrollment limit exhausted.
     */
    OfferRedemptionError["OFFER_GROUP_LIMIT_EXHAUSTED"] = "OFFER_GROUP_LIMIT_EXHAUSTED";
    /**
     * INCORRECT_TIER - User is trying to enroll into an offer for a tier they are not part of.
     */
    OfferRedemptionError["INCORRECT_TIER"] = "INCORRECT_TIER";
    /**
     * DEVICE_LIMIT_EXHAUSTED - User device limit exhausted.
     */
    OfferRedemptionError["DEVICE_LIMIT_EXHAUSTED"] = "DEVICE_LIMIT_EXHAUSTED";
    OfferRedemptionError["UNRECOGNIZED"] = "UNRECOGNIZED";
})(OfferRedemptionError || (exports.OfferRedemptionError = OfferRedemptionError = {}));
function offerRedemptionErrorFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_OFFER_REDEMPTION_ERROR':
            return OfferRedemptionError.INVALID_OFFER_REDEMPTION_ERROR;
        case 1:
        case 'ALREADY_REDEEMED':
            return OfferRedemptionError.ALREADY_REDEEMED;
        case 2:
        case 'USER_INELIGIBLE':
            return OfferRedemptionError.USER_INELIGIBLE;
        case 3:
        case 'CODE_NOT_FOUND':
            return OfferRedemptionError.CODE_NOT_FOUND;
        case 4:
        case 'TOO_MANY_CODES':
            return OfferRedemptionError.TOO_MANY_CODES;
        case 5:
        case 'EXPIRED':
            return OfferRedemptionError.EXPIRED;
        case 6:
        case 'NOT_STARTED':
            return OfferRedemptionError.NOT_STARTED;
        case 7:
        case 'OFFER_GROUP_LIMIT_EXHAUSTED':
            return OfferRedemptionError.OFFER_GROUP_LIMIT_EXHAUSTED;
        case 8:
        case 'INCORRECT_TIER':
            return OfferRedemptionError.INCORRECT_TIER;
        case 9:
        case 'DEVICE_LIMIT_EXHAUSTED':
            return OfferRedemptionError.DEVICE_LIMIT_EXHAUSTED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return OfferRedemptionError.UNRECOGNIZED;
    }
}
exports.offerRedemptionErrorFromJSON = offerRedemptionErrorFromJSON;
function offerRedemptionErrorToJSON(object) {
    switch (object) {
        case OfferRedemptionError.INVALID_OFFER_REDEMPTION_ERROR:
            return 'INVALID_OFFER_REDEMPTION_ERROR';
        case OfferRedemptionError.ALREADY_REDEEMED:
            return 'ALREADY_REDEEMED';
        case OfferRedemptionError.USER_INELIGIBLE:
            return 'USER_INELIGIBLE';
        case OfferRedemptionError.CODE_NOT_FOUND:
            return 'CODE_NOT_FOUND';
        case OfferRedemptionError.TOO_MANY_CODES:
            return 'TOO_MANY_CODES';
        case OfferRedemptionError.EXPIRED:
            return 'EXPIRED';
        case OfferRedemptionError.NOT_STARTED:
            return 'NOT_STARTED';
        case OfferRedemptionError.OFFER_GROUP_LIMIT_EXHAUSTED:
            return 'OFFER_GROUP_LIMIT_EXHAUSTED';
        case OfferRedemptionError.INCORRECT_TIER:
            return 'INCORRECT_TIER';
        case OfferRedemptionError.DEVICE_LIMIT_EXHAUSTED:
            return 'DEVICE_LIMIT_EXHAUSTED';
        case OfferRedemptionError.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.offerRedemptionErrorToJSON = offerRedemptionErrorToJSON;
//# sourceMappingURL=offer-redemption-error.js.map